import React, {Component} from "react";
import {
	Box,
	Grid,
	Backdrop,
	Skeleton,
	Container,
	CircularProgress,
} from "@mui/material";
import {
	PaymentCard,
	FilterSection,
	DialogChangeCountry
} from "./components";
import {AddCircle} from "@mui/icons-material";
import {
	VisibleContent,
	HeadTitleGoBack,
} from "../../../components";
import getTrans from "../../../languages/getTrans";

class TopUpBalance extends Component {
	constructor(props) {
		super(props);

		this.state = {
			countryGroup: null,
			isBackdrop: false
		};
		this.refDialogChangeCountry = React.createRef();
	}

	componentDidMount = async () => {
		await this.props.getCountries();
	}

	changeCountry = async (countryId) => {
		if (!countryId) {
			this.refDialogChangeCountry.current.open({
				onSubmit: this.changeCountry.bind(this),
			});
			return
		}
		this.setState({isBackdrop: true});
		const country = this.props.countries.find((t)=>t.id === countryId);
		await this.props.changeCountry(country);
		this.refDialogChangeCountry.current.close();
		this.setState({isBackdrop: false});
	}
	getFilteredPayItems = () => {
		const { payItems } = this.props;
		const { countryGroup } = this.state;

		let filtered = payItems;
		if (countryGroup) {
			filtered = payItems.filter(payment => payment.groupSlug === countryGroup);
		}

		const uniquePayments = filtered.reduce((acc, payment) => {
			if (!acc.find(item => item.paymentMethodId === payment.paymentMethodId)) {
				acc.push(payment);
			}
			return acc;
		}, []);

		return uniquePayments;
	}

	render () {
		const {
			payItems,
			countries,
			countryGroups,

			isLoadingCountries,
			isLoadingCountryGroups,
		} = this.props;
		const {
			countryGroup,
			isBackdrop
		} = this.state;
		if (isLoadingCountries) {
			return (
				<Container>
					<HeadTitleGoBack title={getTrans('topUpBalance.Пополнение баланса')} isGoBack={true} Icon={AddCircle} />

				</Container>
			)
		}
		const filteredPayItems = this.getFilteredPayItems();
		return (
			<Container>
				<HeadTitleGoBack title={getTrans('topUpBalance.Пополнение баланса')} isGoBack={true} Icon={AddCircle} />
				<Container sx={{height: "calc(100vh - 148px)", overflow: "auto", padding: "0", marginBottom: "-78px", paddingBottom: "78px", width: "auto", marginRight: "-10px", paddingRight: "10px"}}>
					<Box mt={1}/>
					<FilterSection
						groups={countryGroups}
						countryGroup={countryGroup}
						onChangeCountry={this.changeCountry}
						onChangeGroup={(val) => this.setState({countryGroup: val})}
					/>
					<Box mt={1}/>

					<Grid container spacing={1}>
						<VisibleContent visible={Boolean(isLoadingCountryGroups)}>
							<Grid item xs={12}><Skeleton sx={{height: 64, transform: "initial"}}/></Grid>
							<Grid item xs={12}><Skeleton sx={{height: 64, transform: "initial"}}/></Grid>
							<Grid item xs={12}><Skeleton sx={{height: 64, transform: "initial"}}/></Grid>
						</VisibleContent>
						<VisibleContent visible={!Boolean(isLoadingCountryGroups)}>
							{filteredPayItems.map((payment) => (
								<Grid key={`item-${payment.paymentMethodId}`} item xs={12}>
									<PaymentCard item={payment}/>
								</Grid>
							))}
						</VisibleContent>
					</Grid>
				</Container>

				<DialogChangeCountry ref={this.refDialogChangeCountry} countries={countries}/>
				<Backdrop open={isBackdrop}>
					<CircularProgress/>
				</Backdrop>
			</Container>
		);
	}
}

export default TopUpBalance
